export function buildSynopsisPrompt(data) {
  const fmtList = (arr) => arr?.length
    ? arr.map((item, i) => `  ${i + 1}. ${item}`).join('\n')
    : '  Not specified'

  return `You are a senior doctoral supervisor and research proposal specialist with 40 years of experience across management, social sciences, technology, and policy domains.

Write a complete Research Synopsis (Doctoral Research Proposal) for the following candidate.

CANDIDATE DETAILS:
Name: ${data.candidateName || data.name}
University: ${data.university}
Programme: ${data.programme}
Proposed Thesis Title: ${data.title}
Research Topic: ${data.researchTopic}
Domain: ${data.domain}
Methodology Preference: ${data.methodology}
Number of Research Objectives: ${data.numObjectives || 4}
Target Word Count: ${data.targetWords || 2500} words
${data.theoreticalFrameworks ? `Theoretical Frameworks to include: ${data.theoreticalFrameworks}` : ''}
Keywords: ${Array.isArray(data.keywords) ? data.keywords.join(', ') : (data.keywords || 'Not specified')}

${data.references ? `REFERENCES PROVIDED:\n${data.references}` : ''}

REQUIRED STRUCTURE:
Write each section with its proper heading, in this exact order:

1. Title (just the proposed thesis title, bold, centered)
2. Introduction & Background (300–400 words)
3. Problem Statement (200–300 words)
4. Research Objectives (${data.numObjectives || 4} objectives, numbered)
5. Research Questions (aligned to objectives)
6. Literature Review Overview (400–500 words)
7. Research Methodology (400–500 words)
8. Expected Outcomes & Significance (200–300 words)
9. Proposed Chapter Outline (brief, chapter titles only)
10. Preliminary Bibliography (minimum 20 APA 7th Edition citations)

WRITING REQUIREMENTS — READ CAREFULLY:

1. PROBLEM STATEMENT: Must identify a SPECIFIC gap in the existing literature or practice, not just state broad importance. Name what has not been studied, or what has been studied inadequately, or what contradicts existing theory in this context.

2. RESEARCH OBJECTIVES: Must follow SMART criteria — Specific, Measurable, Achievable, Relevant, Time-bound. State measurability explicitly: "To quantify...", "To identify and compare...", "To develop and validate a framework...". Write exactly ${data.numObjectives || 4} objectives.

3. METHODOLOGY: Must justify the chosen approach PHILOSOPHICALLY, not just procedurally. Address ontology (what is the nature of reality in this domain?) and epistemology (how can we know it?). Then describe the practical approach: sampling, instruments, analysis methods.

4. LITERATURE REVIEW OVERVIEW: Must be ANALYTICAL. Name theoretical tensions that exist in the literature. Do not just list scholars — say what they argue and where they contradict each other. Identify what this research adds.

5. HUMANIZER RULES:
   - Do NOT begin sections with "This section examines..." or "In this chapter we will..."
   - Do NOT use "Furthermore", "Moreover", "Additionally" as sentence openers more than once per section
   - Do NOT use: "delve", "testament", "pivotal", "groundbreaking", "landscape" (as metaphor)
   - Vary sentence length deliberately
   - State contested positions directly

6. PROFESSOR EFFECT:
   - Acknowledge contradictions in the literature
   - Name theoretical tensions explicitly
   - The literature overview should pick a position on unresolved debates

7. REFERENCES: Must be real, verifiable academic sources. Use well-known seminal works. If a specific recent work would be ideal but you are not certain of exact publication details, include it and mark [verify DOI]. Minimum 20 citations.

8. FORMAT: Use APA 7th Edition heading hierarchy and in-text citations throughout.

Write the complete synopsis now. Begin directly with the title, then each numbered section.`
}
